export default "__VITE_ASSET__CC0R_Pk$__"